import Controller from "csi/action/Controller";
import localeProvider from "csi/page/localeProvider";
import declare from "dojo/_base/declare";
import ExternalAPIWizardStore from "./ExternalAPIWizardStore";

const ExternalAPIConnectorSetupController = declare(Controller, {

	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { m_cache, m_writer, widget } = this;
		props.store = new ExternalAPIWizardStore(localeProvider, m_writer, m_cache, widget, this.getNode(), props.onClose, props.onSave);
	},
});

export = ExternalAPIConnectorSetupController;